import FishermanListScreen from "../../screens/MainPage/FishermanListScreen";

export default FishermanListScreen;



// WEBPACK FOOTER //
// ./src/containers/MainPage/FishermanList.js